import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/service/api.service';
import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatDatepickerInputEvent } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { numValidation } from 'src/app/service/customValidation';
import { Select2OptionData } from 'ng-select2';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { DataPassingService } from 'src/app/service/data-passing.service';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-fees-payment',
  templateUrl: './fees-payment.component.html',
  styleUrls: ['./fees-payment.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class FeesPaymentComponent implements OnInit {
  branchName:string='';
  branchAddress:string='';
  isForm=true;
  isReceipt=false;
  isSubmitted=false;
  isSuccess=false;
  isError=false;
  message='';
  inputFormGroup:FormGroup;
  isGreater=false;
  isDisabled=false;
  searching = false;
  searchFailed = false;
  returnData:any=[];
  name='';
  maxValid=false;
  maxDate=new Date();
  fundShort='';
  paymentModeList:Array<Select2OptionData>;
  constructor(private formBuilder:FormBuilder,private api:ApiService,private route:ActivatedRoute,private datePipe:DatePipe,private dataPass:DataPassingService) {
    this.inputFormGroup=this.formBuilder.group({
      id:[''],
      name:['',Validators.required],
      dueDate:['',Validators.required],
      paidAmount:['',[Validators.required,numValidation()]],
      paymentMode:['',Validators.required],
      reference:[''],
      bank:[''],
      remaining:[''],
      donate:[''],
      providerId:[''],
      paymentText:[''],
      fundType:['']
    });
   }

  ngOnInit() {
    this.branchName=localStorage.getItem('branchName');
    this.branchAddress=localStorage.getItem('branchAddress');
    this.paymentModeList=[];
    this.route.data.subscribe(data=>{
      data.feesPayment[0].data.forEach(element => {
        let aData={id:element.id,text:element.name};
        this.paymentModeList.push(aData);
      });
    },(error)=>{});

  }

  searchUser = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => term.length<2 ?[] :
        this.api.get("donar?name="+term).pipe(
          map((response)=>{if(response.status){
            return response.data.map((item,index)=>{
              return {name:item.name,id:item.id,donate:item.provider_amount,remaining:item.remaining_amount,pid:item.loan_provider_id,short:item.short_name,fund:item.fund_type};
            })
          }})
          )
      ),
      tap(() => this.searching = false)
    )

    formatter = (x: {name: string}) => x.name;
    rFormatter=(x: {name: string}) => x.name;

    selectedUser(item){
      this.inputFormGroup.patchValue({id:item.item.id,donate:item.item.donate,remaining:item.item.remaining,providerId:item.item.pid,fundType:item.item.fund});
      this.fundShort=item.item.short;

    }

    reload()
    {
      window.location.reload();
    }

    checkValue()
    {
      let amountToPay;
      if(this.fundShort=="T" || this.fundShort=="S" || this.fundShort=="G")
      {
        amountToPay=this.inputFormGroup.controls.donate.value;
      }
      else
      {
        amountToPay=this.inputFormGroup.controls.remaining.value;
      }
      
     
      let paidAmount=this.inputFormGroup.controls.paidAmount.value;
     
      if(parseInt(paidAmount)<1)
      {
        this.isGreater=true;
        this.isDisabled=true;
      }
      else
      {
       this.isGreater=false;
       this.isDisabled=false;
      }
  
    }

  receiptNo(no)
  {
    let num=no.toString();
    if(num.length<2)
    {
      return '00'+num;
    }
    else if(num.length<3)
    {
      return '0'+num;
    }
    else
    {
      return num;
    }

  }

  changePage(event)
  {
    event.preventDefault();
    this.isForm=!this.isForm;
    this.isReceipt=!this.isReceipt;
  }

  paymentMode(event)
  {
   for(var i=0;i<this.paymentModeList.length;i++)
   {
     if(this.paymentModeList[i].id==event)
     {
       this.inputFormGroup.patchValue({paymentText:this.paymentModeList[i].text});
      
     }
     
   }
   
  }

  print()
  {
    window.print();
  }

  saveForm(form)
  {
    this.returnData=[];
    this.isError=false;
    this.isSuccess=false;
    this.isDisabled=true;
    this.isSubmitted=true;
    if(this.inputFormGroup.invalid)
    {
      this.isDisabled=false;
      return false;
    }
    else
    {
      form.value.name="";
      form.value.dueDate=(form.value.dueDate!="")?this.datePipe.transform(form.value.dueDate,"dd/MM/yyyy"):'';
      this.api.post(form.value,'transaction').subscribe(data=>{
        if(data.status)
        {
         /* this.api.get('totalDues').subscribe(rtotal=>{
              this.dataPass.passDataService({total:rtotal.total});
          },(error)=>{});*/
          this.isForm=!this.isForm;
          this.isReceipt=!this.isReceipt;
          this.returnData=data.details;
          this.returnData['name']=document.querySelector<HTMLInputElement>("#name").value;
          this.returnData['paymentText']=this.inputFormGroup.controls.paymentText.value;
         
        }
        else
        {
          this.isError=true;
          this.message=data.message;
        }

        this.isSubmitted=false;
        this.isDisabled=false;
        this.inputFormGroup.reset();
        document.querySelector<HTMLInputElement>("#name").value='';
      },(error)=>{});

    }
  }

  dateTranform()
  {
    let dt=new Date();
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  convertNumberToWords(num) {
    let n;
    var a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
    var b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
    if ((num = num.toString()).length > 9) return 'overflow';
    n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
    return str;

  }

  dateEvent(type: string, event: MatDatepickerInputEvent<any>) {
    this.isDisabled=false;
    this.maxValid=false;
    let dt=event.value._d;
    let nwDt=new Date();
    if(dt>=nwDt)
    {
      this.isDisabled=true;
      this.maxValid=true;
     
      
    }
  }

}
